export function makeActionCreator(type, ...argNames) {
    return function(data) {
        const action = { type, payload: {} };
        argNames.forEach((arg, index) => {
            action.payload[argNames[index]] = data[arg];
        });
        return action;
    };
}
